import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

const BrandingContext = createContext();

export function BrandingProvider({ children }) {
  const { api, token } = useAuth();
  const [branding, setBranding] = useState({
    app_name: 'HomeCommand',
    app_tagline: 'House Manager',
    app_logo: '',
    app_favicon: ''
  });

  const fetchBranding = useCallback(async () => {
    try {
      // Try authenticated endpoint first, fallback to public
      const endpoint = token ? '/settings' : '/settings/public';
      const res = await api.get(endpoint);
      setBranding({
        app_name: res.data.app_name || 'HomeCommand',
        app_tagline: res.data.app_tagline || 'House Manager',
        app_logo: res.data.app_logo || '',
        app_favicon: res.data.app_favicon || ''
      });
    } catch (e) { /* settings not available */ }
  }, [api, token]);

  useEffect(() => { fetchBranding(); }, [fetchBranding]);

  // Update favicon dynamically
  useEffect(() => {
    if (branding.app_favicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
      link.href = branding.app_favicon;
    }
    if (branding.app_name) {
      document.title = branding.app_name;
    }
  }, [branding.app_favicon, branding.app_name]);

  return (
    <BrandingContext.Provider value={{ ...branding, refreshBranding: fetchBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  const ctx = useContext(BrandingContext);
  if (!ctx) return { app_name: 'HomeCommand', app_tagline: 'House Manager', app_logo: '', app_favicon: '' };
  return ctx;
}
